import { trackAutoEvent } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'page_any_action';


export default () => {
  trackAutoEvent(EVENT_NAME, null, { once: true });
};



// WEBPACK FOOTER //
// ./src/lib/track-event/any-action.js